var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/inherits");

// Generated by CoffeeScript 2.4.1
(function () {
  var XMLCharacterData, XMLNode;
  XMLNode = require('./XMLNode'); // Represents a character data node

  module.exports = XMLCharacterData = function () {
    var XMLCharacterData =
    /*#__PURE__*/
    function (_XMLNode) {
      "use strict";

      _inherits(XMLCharacterData, _XMLNode);

      // Initializes a new instance of `XMLCharacterData`
      function XMLCharacterData(parent) {
        var _this;

        _classCallCheck(this, XMLCharacterData);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(XMLCharacterData).call(this, parent));
        _this.value = '';
        return _this;
      } // Creates and returns a deep clone of `this`


      _createClass(XMLCharacterData, [{
        key: "clone",
        value: function clone() {
          return Object.create(this);
        } // DOM level 1 functions to be implemented later

      }, {
        key: "substringData",
        value: function substringData(offset, count) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }, {
        key: "appendData",
        value: function appendData(arg) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }, {
        key: "insertData",
        value: function insertData(offset, arg) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }, {
        key: "deleteData",
        value: function deleteData(offset, count) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }, {
        key: "replaceData",
        value: function replaceData(offset, count, arg) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }, {
        key: "isEqualNode",
        value: function isEqualNode(node) {
          if (!_get(_getPrototypeOf(XMLCharacterData.prototype), "isEqualNode", this).call(this, node)) {
            return false;
          }

          if (node.data !== this.data) {
            return false;
          }

          return true;
        }
      }]);

      return XMLCharacterData;
    }(XMLNode);

    ; // DOM level 1

    Object.defineProperty(XMLCharacterData.prototype, 'data', {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        return this.value = value || '';
      }
    });
    Object.defineProperty(XMLCharacterData.prototype, 'length', {
      get: function get() {
        return this.value.length;
      }
    }); // DOM level 3

    Object.defineProperty(XMLCharacterData.prototype, 'textContent', {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        return this.value = value || '';
      }
    });
    return XMLCharacterData;
  }.call(this);
}).call(this);